// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2ElfQ","filesListContainer":"PosDisputesFiles_filesListContainer__7m0hX","filesButton":"PosDisputesFiles_filesButton__C8TX0"};